import React from 'react';
import { Badge, Spinner, Table } from 'react-bootstrap'

import DefaultButton from 'components/mycomponents/DefaultButton';
import moment from 'moment/moment';

const Data = ({
    dataMain,
    actionDetail,
    numberStart,
    isLoading
}) => {
    return (
        <Table responsive striped hover bordered size="sm">
            <thead>
                <tr>
                    <th scope="col">No</th>
                    <th scope="col">Kode</th>
                    <th scope="col">Nama</th>
                    <th scope="col">Alamat</th>
                    <th scope="col">No HP / WA</th>
                    <th scope="col">Keperluan</th>
                    <th scope="col">Tanggal</th>
                    <th scope="col">Durasi</th>
                    <th scope="col">Total Unit</th>
                    <th scope="col">Status</th>
                    <th className="text-end" scope="col" width="6%">
                        Aksi
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading ? (<tr>
                        <td colSpan={6} align="center" valign="middle">
                            <Spinner animation="border  " className="me-2" />
                            <span className="fs-4">Loading ...</span>
                        </td>
                    </tr>) :
                    dataMain ? dataMain.map((val, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{numberStart + 1 + idx}</td>
                                <td>{val.vccode}</td>
                                <td style={{ maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{val.vcname}</td>
                                <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{val.vcaddress}</td>
                                <td>{val.vcphone}</td>
                                <td style={{ maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{val.vcnecessary}</td>
                                <td>{moment(val.dtloan).format('DD-MM-YYYY')}</td>
                                <td>{val.intduration} Hari</td>
                                <td>{val.inttotal_unit}</td>
                                <td> <Badge bg={val.intstatus === 0 ? 'warning' : val.intstatus === 1 ? 'success' : 'danger'}>{val.intstatus === 0 ? 'Menunggu Persetujuan' : val.intstatus === 1 ? 'Disetujui' : 'Ditolak'}</Badge></td>
                                <td className="text-end">
                                    <DefaultButton icon="info" title="Detail Data" variant="action" className="p-0 me-3" clickAction={actionDetail} clickParam={val.intid} />
                                </td>
                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan={6}>Data Tidak Tersedia.</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
}

Data.propTypes = {}

export default Data;